var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{key:_vm.$ui.key},[_vm._t("default"),_c('layout-toast'),_c('layout-modal'),_c('layout-modal-loading'),_vm._l((_vm.components),function(component){return _c(component,{key:component,tag:"component"})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }